export class Log {
  static _name: string = "GMCore";
  static _isDev: boolean = false;

  static get name(): string {
    return `[${Log._name}]`;
  }

  public static d(message?: any, ...optionals: any[]) {
    if (Log._isDev) {
      console.log(Log.name + message, ...optionals);
    }
  }

  public static e(message?: any, ...optionals: any[]) {
    if (Log._isDev) {
      console.error(Log.name + message, ...optionals);
    }
  }
}

console.debug = (message?: any, ...optionals: any[]) =>
  Log._isDev ? console.log(message, ...optionals) : null;
